import axiosInstance from "../utils/axiosInstance"
import { API_ENDPOINTS } from "../constants/config"

const getAuthHeader = () => {
  const token = localStorage.getItem("token")
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export const downloadInventoryTemplate = async (includeData = false) => {
  const response = await axiosInstance.get(API_ENDPOINTS.inventoryImportTemplate, {
    params: includeData ? { includeData: "true" } : {},
    responseType: "blob",
    headers: getAuthHeader(),
  })
  return response.data
}

export const exportInventoryData = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.inventoryExport, {
    responseType: "blob",
    headers: getAuthHeader(),
  })
  return response.data
}

export const validateInventoryImport = async (file) => {
  const formData = new FormData()
  formData.append("file", file)
  const response = await axiosInstance.post(API_ENDPOINTS.inventoryImportValidate, formData, {
    headers: {
      ...getAuthHeader(),
      "Content-Type": "multipart/form-data",
    },
  })
  return response.data
}

export const resolveInventoryImportMasters = async (file, resolutions) => {
  const formData = new FormData()
  formData.append("file", file)
  formData.append("resolutions", JSON.stringify(resolutions))
  const response = await axiosInstance.post(API_ENDPOINTS.inventoryImportResolve, formData, {
    headers: {
      ...getAuthHeader(),
      "Content-Type": "multipart/form-data",
    },
  })
  return response.data
}

export const confirmInventoryImport = async (inventoryData) => {
  const response = await axiosInstance.post(
    API_ENDPOINTS.inventoryImportConfirm,
    { inventoryData },
    { headers: getAuthHeader() },
  )
  return response.data
}
